/**
 * Safe user-facing message from axios / API error payloads.
 *
 * @param {unknown} error
 * @param {string} [fallback]
 * @returns {string}
 */
export function apiErrorMessage(error, fallback = "An error occurred") {
	if (!error) {
		return fallback;
	}
	if (!error.response) {
		const msg = error.message;
		return typeof msg === "string" && msg.trim() ? msg : fallback;
	}
	const data = error.response.data;
	if (!data || typeof data !== "object") {
		return fallback;
	}
	const m = data.message;
	if (typeof m === "string" && m.trim()) {
		return m;
	}
	if (m != null && m !== "") {
		return String(m);
	}
	if (data.errors && typeof data.errors === "object") {
		const vals = Object.values(data.errors).flat();
		const first = vals.find(
			(x) => typeof x === "string" && String(x).trim() !== "",
		);
		if (first) {
			return String(first);
		}
	}
	return fallback;
}
